module.exports = __webpack_public_path__ + "static/media/greco_f_thumb.4226e0c9.webp";